exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.entry-wrapper[data-v-0524f402]{margin-bottom:60px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n.entry-wrapper .slice[data-v-0524f402]{width:80%\n}\n.entry-wrapper .slice-image[data-v-0524f402]{background-size:cover !important;width:100%;height:40vh\n}\n.entry-wrapper h1[data-v-0524f402]{font-weight:700;font-size:2.2em;margin:48px 0 50px 0\n}\n.entry-wrapper hr[data-v-0524f402]{margin:0;border:2px solid #fecc39;margin-bottom:36px;display:block;clear:both;width:55px\n}\n@media(max-width: 1024px){\n.entry-wrapper hr[data-v-0524f402]{display:none\n}\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0524f402","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NewsEntry.vue
// module id = Wunz
// module chunks = 1